<template>
  <div class="floating-button-menu">
    <CaModal v-if="errorsFileUploaded" :opened="hasErrorOnUpload" @close.self="errorsFileUploaded = []">
      <div slot="title">
        <h5 class="ev-modal__title">
          Problème lors de l'import
        </h5>
      </div>
      <div v-for="errorFileUploaded in errorsFileUploaded" :key="errorFileUploaded" slot="body">
        <ul>
          <li class="error-message">
            <div class="">
              <i class="even-icon-erreur" />
            </div>
            {{ errorFileUploaded }}
          </li>
        </ul>
      </div>
      <div slot="footer">
        <button type="button"
                class="ev-btn outline-btn small"
                data-dismiss="ev-modal"
                @click.self="errorsFileUploaded = []">
          Fermer
        </button>
      </div>
    </CaModal>
    <input v-show="false"
           ref="fileInput"
           type="file"
           @change="getImage">
    <button class="btn btn-primary-ca floating-button-menu__button--photo"
            :class="{'buttondisplay' : hasErrorOnUpload}"
            @click="takePhoto">
      <span :class="`even-icon-camera-picture`" />
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import apis from '@/apis';
import CaModal from '@/components/molecules/CaModal.vue';

export default {
  name: 'PhotoFloatingButtonMenu',
  components: {
    CaModal,
  },
  data() {
    return {
      menuOpen: false,
      uploadableFileMimeTypes: null,
      maxFileSizeUpload: 0,
      errorsFileUploaded: [],
      typesAllowed: {
        mimeTypes: [],
        extensions: [],
      },
      maxFileSizeUploadInBytes: {
        size: 0,
        human: '',
      },
    };
  },
  computed: {
    ...mapState([
      'importedFile',
    ]),
    hasErrorOnUpload() {
      return this.errorsFileUploaded.length > 0;
    },
  },
  mounted() {
    apis.Document.getServerUploadInfos().then(({ data: { typesAllowed, maxFileSizeUploadInBytes } }) => {
      this.typesAllowed = typesAllowed;
      this.maxFileSizeUploadInBytes = maxFileSizeUploadInBytes;
    });
  },
  methods: {
    ...mapMutations({
      setImportedFile: 'SET_IMPORTED_FILE',
      setFromRoute: 'SET_FROM_ROUTE',
    }),
    getImage() {
      // eslint-disable-next-line prefer-destructuring
      const fileUploaded = this.$refs.fileInput.files[0];
      const extension = fileUploaded.name.split('.').pop();

      if (fileUploaded.size > this.maxFileSizeUploadInBytes.size) {
        this.errorsFileUploaded.push(`Ce type de fichier n'est pas autorisé car il est trop volumineux (taille maximum autorisée : ${this.maxFileSizeUploadInBytes.human})`);
      }

      if (!this.typesAllowed.extensions.includes(extension)) {
        this.errorsFileUploaded.push(`Ce type de fichier n'est pas autorisé (types autorisé ${this.typesAllowed.extensions.join(',')})`);
      }

      this.$refs.fileInput.value = '';

      if (!this.hasErrorOnUpload) {
        this.setImportedFile(fileUploaded);
        if (fileUploaded.type.indexOf('image/') === 0) {
          this.$router.push({ name: 'Import-Document-Ajuster' });
        } else {
          this.$router.push({ name: 'Import-Document-formulaire' });
        }
      }
    },
    takePhoto() {
      this.setFromRoute(this.$route.path);
      this.$refs.fileInput.setAttribute('capture', '');
      this.$refs.fileInput.setAttribute('accept', 'image/*');
      this.$refs.fileInput.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.floating-button-menu > * {
  z-index: 5;
}

.ev-modal__title {
    display: flex;
    flex-direction: row;
}

.error-message {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1rem;
    font-weight: $font-weight-medium;
    color: $alert-color;
    line-height: 1.2;
}

.even-icon-erreur {
    font-size: 2.5rem;
    color: $alert-color;
    margin: 0 10px 0 0;
}

.floating-button-menu {
  &__button--photo {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 10vh;
    right: 2vh;
    width: 50px;
    height: 50px;

    background: $ev-primary-color;
    color: $white-background-color;
    border: none;
    border-radius: 50px;
    padding: 8px 12px;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, .3);
    outline: none;
    font-size: 1.8rem;

    > span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.buttondisplay {
  display: none;
}
</style>
